import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams, Link } from "react-router-dom";
import { apiRoutesUrls } from "../../Api/ApiNames";
import { typeOfImageToLink, typeOfCategoryToLink } from '../../Components/Helpers/selectType';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import './Advertisement.css';
import translation from "../../Components/Helpers/translation";
import styles from './Advertisement.module.scss';


function AdvertisementSquare() {
	const [combinedData, setCombinedData] = useState([]);
	const history = useHistory();
	const { lang } = useParams();
	const splideRef = useRef(null);
	const [isPaused, setIsPaused] = useState(false);

	const searchHandler = () => {
		const keyword = document.getElementById("search").value;
		if (keyword) {
			history.push(`/${lang}/szukaj/values?keyword=${keyword}&search_fields=[]`);
			window.location.reload(true);
		}
	};

	const handleMouseEnter = () => {
		setIsPaused(true);
		if (splideRef.current?.splide) {
			splideRef.current.splide.pause();
		}
	};

	const handleMouseLeave = () => {
		setIsPaused(false);
		if (splideRef.current?.splide) {
			splideRef.current.splide.play();
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				const res1 = await fetch(`${apiRoutesUrls.main}${apiRoutesUrls.mainPage}44?limit=5&offset=0&lang=${lang}`);
				const json1 = await res1.json();

				const res2 = await fetch(`${apiRoutesUrls.main}${apiRoutesUrls.mainPage}47?limit=4&offset=0&lang=${lang}`);
				const json2 = await res2.json();

				setCombinedData([...json1, ...json2]);
			} catch (error) {
				console.error("Błąd podczas pobierania danych:", error);
			}
		};

		fetchData();
	}, [lang]);

	useEffect(() => {
		const keyDown = (event) => {
			if (event.key === "Enter") {
				searchHandler();
			}
		};
		window.addEventListener('keydown', keyDown);
		return () => window.removeEventListener('keydown', keyDown);
	});

	return (
		<>
			<div className={styles.leftMenu}>
				<div aria-label={translation.aria.header.logoDMP} title={translation.aria.header.logoDMP} tabIndex={0}>
					<div className={`${lang === "pl" ? styles.dmpPL : styles.dmpEN}`} />
				</div>
			</div>
			<div className={'wrapper'}>
				{combinedData.length > 0 && (


					<Splide
						ref={splideRef}
						options={{
							type: 'loop',
							perPage: 2,
							gap: '1rem',
							autoplay: true,
							interval: 4000,
							arrows: false,
							pagination: false,
							pauseOnHover: false,
							drag: false,
							breakpoints: {
								1024: { perPage: 2 },
								768: { perPage: 1 },
							},
							autoScroll: {
								speed: 1.2,
								pauseOnHover: false,
								pauseOnFocus: false,
							},
						}}
						aria-label="Combined Slider"

					>
						{combinedData.map((item, index) => (
							<SplideSlide key={index}>
								<a href={typeOfCategoryToLink(item, lang)}
									aria-label={`${translation.wcagLabels.mainPage.highlighted} - "${item.title}"`}
									title={`${translation.wcagLabels.mainPage.highlighted} - "${item.title}"`}
									className={styles.linkWrapper} 
									target='_blank'
									rel='noreferrer'
								>
									<div
										className={'bigImage'}
										style={{ backgroundImage: `url(${typeOfImageToLink(item)})` }}
									/>
								</a>
							</SplideSlide>

						))}
					</Splide>

				)}
			</div >
		</>


	);
}

export default AdvertisementSquare;